import { render, staticRenderFns } from "./accessibility-options.vue?vue&type=template&id=67c488ec"
import script from "./accessibility-options.vue?vue&type=script&lang=js"
export * from "./accessibility-options.vue?vue&type=script&lang=js"
import style0 from "./accessibility-options.vue?vue&type=style&index=0&id=67c488ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports